// extracted by mini-css-extract-plugin
module.exports = {"title":"e_yv","excerpt":"e_zv","container":"e_Av","imageContainer":"e_Bv","image":"e_Cv","postedBy":"e_Dv","postedByDate":"e_Ev"};